module.exports = __webpack_public_path__ + "img/0119.85cda566.png";